// Phase A flip: /dashboard redirects to the new parent home at
// /parent. Legacy DashboardScreen.jsx goes dormant (deleted in
// Phase B).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard")({
  beforeLoad: () => {
    throw redirect({ to: "/parent" });
  },
  component: () => null,
});
